const $ = jQuery.noConflict();

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
class MegaMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find('> .menu > .menu-item-type-post_type');
		this.menuItemsLinks = this.menuItems.find('> a');
	}
	static hideMegaMenu() {
		if ($('.mega-menu-wrapper.active').length > 0) {
			clearTimeout(MegaMenu.menuTimeout);
			const activeMegaMenu = $('.mega-menu-wrapper.active');
			const activeMenuTrigger = $('a.is-active-trigger');
			const activeMegaMenuItems = activeMegaMenu.find('*');

			$(document.body).removeClass('mega-menu-is-active');
			activeMegaMenu.removeClass('active');
			activeMegaMenuItems.removeClass('active');
			activeMenuTrigger.removeClass('is-active-trigger');
		}
	}
	static hideMegaMenuOnTouch(e) {
		const container = $('.main-header__nav');
		if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mega-menu-wrapper').hasClass('active')) {
			MegaMenu.hideMegaMenu();
		}
	}
	static animateItemsIn(items) {
		let delay = 0;
		items.each((i, v) => {
			delay += 0.02;
			$(v).css('transition-delay', `${delay}s`);
			$(v).addClass('active');
		});
	}
	bindEvents() {
		this.menuItemsLinks.on('click', this.toggleMegaMenu);
		$(document).on('click touchstart', MegaMenu.hideMegaMenuOnTouch);
	}
	toggleMegaMenu(e) {
		e.preventDefault();
		const megaMenuWrapper = $(this).next('.mega-menu-wrapper');
		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');
		const timer = $('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;

		if (megaMenuWrapper.hasClass('active')) {
			MegaMenu.hideMegaMenu();
			return;
		} else {
			MegaMenu.hideMegaMenu();
		}

		MegaMenu.menuTimeout = setTimeout(() => {
			megaMenuCols.each((i, v) => {
				MegaMenu.animateItemsIn($(v).find('*'));
			});

			$(document.body).addClass('mega-menu-is-active');
			megaMenuWrapper.addClass('active');
			$(this).addClass('is-active-trigger');
		}, timer);

		$('#searchform input').val('Search');
	}
	init() {
		this.bindEvents();
	}
}
export default new MegaMenu();
